import whiteHomeIcon from './../../assets/home_white.png'
import blackHomeIcon from './../../assets/home_black.png'
import './GoHome.css'
import {useNavigate,useLocation} from 'react-router-dom'

function GoHome() {
    const navigate = useNavigate()
    const location = useLocation()
    
    const pathMatchRoute = (route) => {
       if(route === location.pathname){
           return true
       }
   } 
    return (
        <div>
        <button onClick={() => navigate('/')} className={`go-home-button ${pathMatchRoute('/') ?  'white-bkg': 'gradient-bkg'}`}> 
             <img src={pathMatchRoute('/') ? blackHomeIcon : whiteHomeIcon}  className='home-icon' alt="go-home"/>
        </button>
        </div>
    )
}

export default GoHome
